// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aside-styles_wrapper__CFgNG {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 140;
    transition: width 0.4s;
    width: var(--sidebar-collapsed-width);
    /*background: rgb(from var(--light-grey) r g b / 0.2);*/
    background-color: color-mix(in oklab, var(--light-grey), white 80%);

    overflow: hidden;
    border-right: 1px solid var(--light-grey);

    font-size: 14px;
    /*font-size: inherit;*/

    --menu-item-padding-y: 7px;
    --menu-item-padding-x: 20px;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .aside-styles_wrapper__CFgNG {
        font-size: 16px;
    }

    .aside-styles_aside__NLwL2 nav {
        margin-top: 20px;
    }
}

.aside-styles_wrapper__CFgNG.aside-styles_open__pfGJ0 {
    width: var(--sidebar-expanded-width);
}

.aside-styles_wrapper__CFgNG:not(.aside-styles_open__pfGJ0) * {
    pointer-events: none;
}

.aside-styles_wrapper__CFgNG:not(.aside-styles_open__pfGJ0) .aside-styles_userMenu__MLdu9,
.aside-styles_wrapper__CFgNG:not(.aside-styles_open__pfGJ0) .aside-styles_userMenu__MLdu9 * {
    pointer-events: auto;
}

.aside-styles_wrapper__CFgNG:not(.aside-styles_open__pfGJ0) {
    cursor: pointer;
}

.aside-styles_fadeAnimation__5qMZe {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.4s;
}

.aside-styles_fadeAnimationActive__0cTiY {
    opacity: 1;
    pointer-events: initial;
}

.aside-styles_aside__NLwL2 {
    --width: var(--sidebar-expanded-width);
    width: var(--width);
    height: 100%;
    display: flex;
    flex-direction: column;
    /*padding: 0 15px;*/
}

.aside-styles_asideLogo__8MY9q {
    width: 30px;
    height: auto;
}

.aside-styles_header__PX9wP {
    height: var(--header-height);
    min-height: var(--header-height);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    padding: 0 16px;
}

.aside-styles_aside__NLwL2 nav {
    margin-top: 10px;
    flex: 1 1;
    display: flex;
    flex-direction: column;
}

.aside-styles_menuItemsContainer__slOpu.aside-styles_standalone__C8B13 {
    margin-top: -20px;
}

.aside-styles_menuItemsContainer__slOpu {
    /*transition:*/
    /*    opacity 0.4s,*/
    /*    max-height 0.4s;*/
    /*opacity: 1;*/
    /*max-height: 5000px;*/
    /*overflow: hidden;*/
}

.aside-styles_menuItemsContainer__slOpu.aside-styles_collapsed__6jCHU {
    opacity: 0;
    max-height: 0;
    margin-top: 0;
    margin-bottom: 0;
}

.aside-styles_menuItem__xRUuf {
    display: flex;
    flex-direction: column;
    column-gap: 10px;
    /*margin-bottom: 14px;*/
    padding: var(--menu-item-padding-y) 10px var(--menu-item-padding-y) var(--menu-item-padding-x);
}

.aside-styles_menuItem__xRUuf.aside-styles_disabled__iSyvY .aside-styles_menuText__zq0Ko {
    color: var(--dark-grey);
}

.aside-styles_menuLabel__6C7LC {
    display: flex;
    align-items: center;
    grid-gap: 10px;
    --icon-color-custom: var(--primary-color-active);
    cursor: pointer;
    font-size: inherit;
    padding: 0;
}

.aside-styles_menuLabel__6C7LC > span:first-child {
    width: 20px;
    max-width: 20px;
    text-align: center;
    display: flex;
    justify-content: center;
}

.aside-styles_menuLabelAbsolute__0Gj4v {
    position: absolute;
    left: 20px;
}

.aside-styles_subMenuItem__EY5i- .aside-styles_menuText__zq0Ko {
    transition: background-color 0.4s;
    border-radius: 2px;
    padding: 4px 2px;
    flex: 1 1;
}

.aside-styles_subMenuItem__EY5i-:hover .aside-styles_menuText__zq0Ko {
    background: rgba(var(--light-grey-rgb), 0.5);
    color: #000000;
}

.aside-styles_subMenu__os9O0 {
    display: flex;
    flex-direction: column;
    padding-left: 24px;
    margin-top: 2px;
}

.aside-styles_subMenuItem__EY5i- {
    padding: 5px 0 5px 9.5px;
    display: flex;
    align-items: center;
    position: relative;
    gap: 1.5px;
}

.aside-styles_subMenuItem__EY5i-:before {
    content: '';
    width: 7.5px;
    height: 0.5px;
    background: #707070;
    display: flex;
}

.aside-styles_subMenuItem__EY5i-:after {
    content: '';
    position: absolute;
    width: 0.5px;
    height: 100%;
    top: -50%;
    background: #707070;
    display: flex;
}

.aside-styles_subMenuItem__EY5i-:first-child:after {
    height: 90%;
    top: -40%;
}

.aside-styles_menuText__zq0Ko {
    transition: opacity 0.4s;
    opacity: 0;
}

.aside-styles_subMenu__os9O0 {
    transition:
        opacity 0.4s,
        max-height 0.4s;
    opacity: 0;
    max-height: 0;
    overflow: hidden;
}

.aside-styles_wrapper__CFgNG.aside-styles_open__pfGJ0 .aside-styles_menuText__zq0Ko,
.aside-styles_subMenu__os9O0.aside-styles_open__pfGJ0 {
    opacity: 1;
}

/*.wrapper:not(.open) button {*/
/*    pointer-events: none;*/
/*}*/

.aside-styles_subMenu__os9O0.aside-styles_open__pfGJ0 {
    max-height: 400px;
}

.aside-styles_hamburger__WDxWb {
    --height: 18px;
    --width: 23px;

    --bar-height: 2px;

    border: 0;
    padding: 2px;
    background: transparent !important;
    /*position: fixed;*/
    width: var(--width);
    height: var(--height);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    z-index: 160;
    margin-top: calc(var(--header-height) / 2 - var(--height) / 2 - var(--header-padding-bottom) / 2);
    margin-left: var(--header-padding-sides);
    --background: #3d3d3d;
}

.aside-styles_hamburger__WDxWb span {
    margin: auto 0;
}

.aside-styles_hamburger__WDxWb span,
.aside-styles_hamburger__WDxWb:after,
.aside-styles_hamburger__WDxWb:before {
    display: block;
    border-radius: 2px;
    background: var(--background);
    width: 100%;
    height: var(--bar-height);
    transition:
        opacity 0.4s,
        transform 0.4s,
        background-color 0.4s;
    transform-origin: left center;
}

.aside-styles_hamburger__WDxWb:after,
.aside-styles_hamburger__WDxWb:before {
    content: '';
}

.aside-styles_hamburger__WDxWb.aside-styles_active__ZQznp.aside-styles_menu-aside__QQ-IH {
    --background: #fff;
}

.aside-styles_hamburger__WDxWb.aside-styles_active__ZQznp:before {
    transform: rotate(45deg) translateY(-1px);
}

.aside-styles_hamburger__WDxWb.aside-styles_active__ZQznp:after {
    transform: rotate(-45deg) translateY(1px);
}

.aside-styles_hamburger__WDxWb.aside-styles_active__ZQznp span {
    opacity: 0;
}

.aside-styles_aside__NLwL2 nav a.aside-styles_disabled__iSyvY {
    pointer-events: none;
    color: #7b848e;
}

.aside-styles_borderMenu__YjEPk {
    border-bottom: 1px solid var(--light-grey);
    /*padding-bottom: 10px;*/
}

.aside-styles_borderMenuTop__U48F9 {
    border-top: 1px solid var(--light-grey);
    padding-top: 13px;
    margin-top: 6px;
}

.aside-styles_platformMenu__womvJ {
    transition:
        opacity 0.4s,
        max-height 0.4s,
        margin-bottom 0.4s,
        padding-bottom 0.4s;
    opacity: 1;
    max-height: 100px;
    overflow: hidden;

    padding-bottom: 13px;
    margin-bottom: 6px;
}

.aside-styles_platformMenu__womvJ.aside-styles_collapsed__6jCHU {
    opacity: 0;
    max-height: 0;
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
}

.aside-styles_platformSubMenu__XbzJs {
    opacity: 1 !important;
    max-height: 400px !important;
}

.aside-styles_portalContainer__pMJB7 {
    width: 100%;
    /*margin-top: 10px;*/
    padding-top: 10px;
    /*transition:*/
    /*    opacity 0.4s,*/
    /*    max-height 0.4s;*/
    opacity: 1;
    /*max-height: 2000px;*/
    overflow: auto;
}

.aside-styles_portalContainer__pMJB7 > *:not(.aside-styles_menuLabel__6C7LC) {
    transition: opacity 0.4s;
}

.aside-styles_wrapper__CFgNG:not(.aside-styles_open__pfGJ0) .aside-styles_portalContainer__pMJB7 > *:not(.aside-styles_menuLabel__6C7LC) {
    opacity: 0;
}

.aside-styles_portalContainerOuter__14HN0:not(.aside-styles_active__ZQznp) {
    opacity: 0;
    max-height: 0;
}

.aside-styles_portalContainer__pMJB7.aside-styles_active__ZQznp {
    opacity: 1;
    max-height: calc(100vh - 280px);
}

.aside-styles_portalContainerOuter__14HN0.aside-styles_collapsed__6jCHU {
    opacity: 0;
    max-height: 0;
    margin-top: 0;
}

.aside-styles_menuItemsContainer__slOpu.aside-styles_collapsed__6jCHU .aside-styles_menuItem__xRUuf {
    pointer-events: none;
}

.aside-styles_menuItemBottom__bFGZr {
    margin-top: auto;
    border-top: 1px solid transparent;
    transition: border-top-color 0.4s;
}

.aside-styles_wrapper__CFgNG.aside-styles_open__pfGJ0 .aside-styles_menuItemBottom__bFGZr {
    border-color: var(--light-grey);
}
`, "",{"version":3,"sources":["webpack://./src/layouts/components/Aside/aside-styles.module.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,qCAAqC;IACrC,uDAAuD;IACvD,mEAAmE;;IAEnE,gBAAgB;IAChB,yCAAyC;;IAEzC,eAAe;IACf,sBAAsB;;IAEtB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,8FAA8F;AAClG;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gDAAgD;IAChD,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI;;uBAEmB;IACnB,UAAU;IACV,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;AACd;;AAEA,+BAA+B;AAC/B,4BAA4B;AAC5B,IAAI;;AAEJ;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;;IAEb,iBAAiB;;IAEjB,SAAS;IACT,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iGAAiG;IACjG,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,yBAAyB;IACzB;;;6BAGyB;IACzB,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,wBAAwB;AAC5B;;AAEA;IACI,uCAAuC;IACvC,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;;;;2BAIuB;IACvB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;;IAEhB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;IACV,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC","sourcesContent":["@value screen-lg-min from '../../../breakpoints.css';\n\n.wrapper {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    z-index: 140;\n    transition: width 0.4s;\n    width: var(--sidebar-collapsed-width);\n    /*background: rgb(from var(--light-grey) r g b / 0.2);*/\n    background-color: color-mix(in oklab, var(--light-grey), white 80%);\n\n    overflow: hidden;\n    border-right: 1px solid var(--light-grey);\n\n    font-size: 14px;\n    /*font-size: inherit;*/\n\n    --menu-item-padding-y: 7px;\n    --menu-item-padding-x: 20px;\n}\n\n@media screen-lg-min {\n    .wrapper {\n        font-size: 16px;\n    }\n\n    .aside nav {\n        margin-top: 20px;\n    }\n}\n\n.wrapper.open {\n    width: var(--sidebar-expanded-width);\n}\n\n.wrapper:not(.open) * {\n    pointer-events: none;\n}\n\n.wrapper:not(.open) .userMenu,\n.wrapper:not(.open) .userMenu * {\n    pointer-events: auto;\n}\n\n.wrapper:not(.open) {\n    cursor: pointer;\n}\n\n.fadeAnimation {\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.4s;\n}\n\n.fadeAnimationActive {\n    opacity: 1;\n    pointer-events: initial;\n}\n\n.aside {\n    --width: var(--sidebar-expanded-width);\n    width: var(--width);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    /*padding: 0 15px;*/\n}\n\n.asideLogo {\n    width: 30px;\n    height: auto;\n}\n\n.header {\n    height: var(--header-height);\n    min-height: var(--header-height);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0;\n    padding: 0 16px;\n}\n\n.aside nav {\n    margin-top: 10px;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.menuItemsContainer.standalone {\n    margin-top: -20px;\n}\n\n.menuItemsContainer {\n    /*transition:*/\n    /*    opacity 0.4s,*/\n    /*    max-height 0.4s;*/\n    /*opacity: 1;*/\n    /*max-height: 5000px;*/\n    /*overflow: hidden;*/\n}\n\n.menuItemsContainer.collapsed {\n    opacity: 0;\n    max-height: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.menuItem {\n    display: flex;\n    flex-direction: column;\n    column-gap: 10px;\n    /*margin-bottom: 14px;*/\n    padding: var(--menu-item-padding-y) 10px var(--menu-item-padding-y) var(--menu-item-padding-x);\n}\n\n.menuItem.disabled .menuText {\n    color: var(--dark-grey);\n}\n\n.menuLabel {\n    display: flex;\n    align-items: center;\n    grid-gap: 10px;\n    --icon-color-custom: var(--primary-color-active);\n    cursor: pointer;\n    font-size: inherit;\n    padding: 0;\n}\n\n.menuLabel > span:first-child {\n    width: 20px;\n    max-width: 20px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n}\n\n.menuLabelAbsolute {\n    position: absolute;\n    left: 20px;\n}\n\n.subMenuItem .menuText {\n    transition: background-color 0.4s;\n    border-radius: 2px;\n    padding: 4px 2px;\n    flex: 1;\n}\n\n.subMenuItem:hover .menuText {\n    background: rgba(var(--light-grey-rgb), 0.5);\n    color: #000000;\n}\n\n.subMenu {\n    display: flex;\n    flex-direction: column;\n    padding-left: 24px;\n    margin-top: 2px;\n}\n\n.subMenuItem {\n    padding: 5px 0 5px 9.5px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    gap: 1.5px;\n}\n\n.subMenuItem:before {\n    content: '';\n    width: 7.5px;\n    height: 0.5px;\n    background: #707070;\n    display: flex;\n}\n\n.subMenuItem:after {\n    content: '';\n    position: absolute;\n    width: 0.5px;\n    height: 100%;\n    top: -50%;\n    background: #707070;\n    display: flex;\n}\n\n.subMenuItem:first-child:after {\n    height: 90%;\n    top: -40%;\n}\n\n.menuText {\n    transition: opacity 0.4s;\n    opacity: 0;\n}\n\n.subMenu {\n    transition:\n        opacity 0.4s,\n        max-height 0.4s;\n    opacity: 0;\n    max-height: 0;\n    overflow: hidden;\n}\n\n.wrapper.open .menuText,\n.subMenu.open {\n    opacity: 1;\n}\n\n/*.wrapper:not(.open) button {*/\n/*    pointer-events: none;*/\n/*}*/\n\n.subMenu.open {\n    max-height: 400px;\n}\n\n.hamburger {\n    --height: 18px;\n    --width: 23px;\n\n    --bar-height: 2px;\n\n    border: 0;\n    padding: 2px;\n    background: transparent !important;\n    /*position: fixed;*/\n    width: var(--width);\n    height: var(--height);\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    z-index: 160;\n    margin-top: calc(var(--header-height) / 2 - var(--height) / 2 - var(--header-padding-bottom) / 2);\n    margin-left: var(--header-padding-sides);\n    --background: #3d3d3d;\n}\n\n.hamburger span {\n    margin: auto 0;\n}\n\n.hamburger span,\n.hamburger:after,\n.hamburger:before {\n    display: block;\n    border-radius: 2px;\n    background: var(--background);\n    width: 100%;\n    height: var(--bar-height);\n    transition:\n        opacity 0.4s,\n        transform 0.4s,\n        background-color 0.4s;\n    transform-origin: left center;\n}\n\n.hamburger:after,\n.hamburger:before {\n    content: '';\n}\n\n.hamburger.active.menu-aside {\n    --background: #fff;\n}\n\n.hamburger.active:before {\n    transform: rotate(45deg) translateY(-1px);\n}\n\n.hamburger.active:after {\n    transform: rotate(-45deg) translateY(1px);\n}\n\n.hamburger.active span {\n    opacity: 0;\n}\n\n.aside nav a.disabled {\n    pointer-events: none;\n    color: #7b848e;\n}\n\n.borderMenu {\n    border-bottom: 1px solid var(--light-grey);\n    /*padding-bottom: 10px;*/\n}\n\n.borderMenuTop {\n    border-top: 1px solid var(--light-grey);\n    padding-top: 13px;\n    margin-top: 6px;\n}\n\n.platformMenu {\n    transition:\n        opacity 0.4s,\n        max-height 0.4s,\n        margin-bottom 0.4s,\n        padding-bottom 0.4s;\n    opacity: 1;\n    max-height: 100px;\n    overflow: hidden;\n\n    padding-bottom: 13px;\n    margin-bottom: 6px;\n}\n\n.platformMenu.collapsed {\n    opacity: 0;\n    max-height: 0;\n    margin-bottom: 0;\n    padding-bottom: 0;\n    border-bottom: none;\n}\n\n.platformSubMenu {\n    opacity: 1 !important;\n    max-height: 400px !important;\n}\n\n.portalContainer {\n    width: 100%;\n    /*margin-top: 10px;*/\n    padding-top: 10px;\n    /*transition:*/\n    /*    opacity 0.4s,*/\n    /*    max-height 0.4s;*/\n    opacity: 1;\n    /*max-height: 2000px;*/\n    overflow: auto;\n}\n\n.portalContainer > *:not(.menuLabel) {\n    transition: opacity 0.4s;\n}\n\n.wrapper:not(.open) .portalContainer > *:not(.menuLabel) {\n    opacity: 0;\n}\n\n.portalContainerOuter:not(.active) {\n    opacity: 0;\n    max-height: 0;\n}\n\n.portalContainer.active {\n    opacity: 1;\n    max-height: calc(100vh - 280px);\n}\n\n.portalContainerOuter.collapsed {\n    opacity: 0;\n    max-height: 0;\n    margin-top: 0;\n}\n\n.menuItemsContainer.collapsed .menuItem {\n    pointer-events: none;\n}\n\n.menuItemBottom {\n    margin-top: auto;\n    border-top: 1px solid transparent;\n    transition: border-top-color 0.4s;\n}\n\n.wrapper.open .menuItemBottom {\n    border-color: var(--light-grey);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"wrapper": `aside-styles_wrapper__CFgNG`,
	"aside": `aside-styles_aside__NLwL2`,
	"open": `aside-styles_open__pfGJ0`,
	"userMenu": `aside-styles_userMenu__MLdu9`,
	"fadeAnimation": `aside-styles_fadeAnimation__5qMZe`,
	"fadeAnimationActive": `aside-styles_fadeAnimationActive__0cTiY`,
	"asideLogo": `aside-styles_asideLogo__8MY9q`,
	"header": `aside-styles_header__PX9wP`,
	"menuItemsContainer": `aside-styles_menuItemsContainer__slOpu`,
	"standalone": `aside-styles_standalone__C8B13`,
	"collapsed": `aside-styles_collapsed__6jCHU`,
	"menuItem": `aside-styles_menuItem__xRUuf`,
	"disabled": `aside-styles_disabled__iSyvY`,
	"menuText": `aside-styles_menuText__zq0Ko`,
	"menuLabel": `aside-styles_menuLabel__6C7LC`,
	"menuLabelAbsolute": `aside-styles_menuLabelAbsolute__0Gj4v`,
	"subMenuItem": `aside-styles_subMenuItem__EY5i-`,
	"subMenu": `aside-styles_subMenu__os9O0`,
	"hamburger": `aside-styles_hamburger__WDxWb`,
	"active": `aside-styles_active__ZQznp`,
	"menu-aside": `aside-styles_menu-aside__QQ-IH`,
	"borderMenu": `aside-styles_borderMenu__YjEPk`,
	"borderMenuTop": `aside-styles_borderMenuTop__U48F9`,
	"platformMenu": `aside-styles_platformMenu__womvJ`,
	"platformSubMenu": `aside-styles_platformSubMenu__XbzJs`,
	"portalContainer": `aside-styles_portalContainer__pMJB7`,
	"portalContainerOuter": `aside-styles_portalContainerOuter__14HN0`,
	"menuItemBottom": `aside-styles_menuItemBottom__bFGZr`
};
export default ___CSS_LOADER_EXPORT___;
